import dayjs from 'dayjs'
import i18n from '@ms/lang/i18n.js'

/**
 * Updates the document title with match details based on the provided event object.
 *
 * @param {Object} event - The event object containing match details.
 * @param {string} event.homeTeam - The name of the home team.
 * @param {string} event.awayTeam - The name of the away team.
 * @param {string} event.category - The category of the match (e.g., league or type of sport).
 * @param {string} event.tournament - The name of the tournament.
 * @param {string} event.startTime - The start time of the match in ISO format.
 * @param {string} event.sportId - The sport identifier (e.g., 'sr:sport:1' for soccer).
 */
export function updateMatchDetailTitle(event = {}) {
  const { homeTeam, awayTeam, category, tournament, startTime, sportId } = event
  let title = ''
  // soccer
  if (sportId === 'sr:sport:1') {
    title = `${homeTeam} vs ${awayTeam} Prediction & Results | ${tournament} - Live Score, H2H and Lineups | MSport`
  } else {
    const timeStr = dayjs(startTime).format('HH:mm MM/DD')
    title = `Live score | ${homeTeam} vs ${awayTeam} | ${category}-${tournament} | ${timeStr} | ${i18n.t('COUNTRY_NAME')} | MSport`
  }
  document.title = title
}
